import { INCENTIVE_MEASUREMENT_VOCABULARIES } from './incentive-measurement.js';
/** Slice d496 of the catalog (D577): the vocabularies the incentive measurement (D496) brought. */
export const SLICE_D496 = [...INCENTIVE_MEASUREMENT_VOCABULARIES];
//# sourceMappingURL=slice-d496.js.map